import { authorizeBaseUrl } from "@coherehealth/common";
import { ServiceCase, ServiceRequestStatus } from "@coherehealth/qm-api";

export const EXCLUDED_FAX_OUTCOME_STATUSES = [
  "NEW_SR",
  "NEW_CONTINUATION_SR",
  "EDIT_EXISTING_SR",
  "NEW_REFERRAL",
  "FAX_ATTACHED",
  "FAX_ATTACHED_TO_RF",
];

const isUnassignedOutcome = (caseOutcome: string) => caseOutcome.startsWith("UNASSIGNED");

const shouldShowFaxOutcomePage = (serviceCase: ServiceCase) => {
  const { caseStatus, outcome } = serviceCase;
  const outcomeValue = outcome?.outcome;
  return (
    caseStatus === "COMPLETE" &&
    outcomeValue &&
    !EXCLUDED_FAX_OUTCOME_STATUSES.includes(outcomeValue) &&
    !isUnassignedOutcome(outcomeValue)
  );
};

export function getRedirectUrlServiceCaseDetailsFaxIntake(
  serviceCase: ServiceCase,
  isNewFaxOutcomePageEnabled: boolean
) {
  const caseOutcomeServiceRequests = serviceCase?.outcome?.serviceRequests;
  const serviceRequestId =
    caseOutcomeServiceRequests?.find((request: ServiceRequestStatus) => request?.serviceRequestId)?.serviceRequestId ||
    serviceCase?.serviceRequest?.serviceRequestId;

  const baseUrl = authorizeBaseUrl();
  const caseId = serviceCase.id;

  if (isNewFaxOutcomePageEnabled && shouldShowFaxOutcomePage(serviceCase) && !serviceRequestId) {
    return `${baseUrl}/fax_outcome?caseId=${caseId}`;
  }

  const params = serviceRequestId ? `caseId=${caseId}&serviceRequestId=${serviceRequestId}` : `caseId=${caseId}`;
  return `${baseUrl}/view_only_review?${params}`;
}
